<template>
	<div class="u-tags">
		<div v-for="(item, i) in tags" :key="i" class="item flex-center">{{item}}</div>
	</div>
</template>

<script>
	export default {
		name: 'cTags',
		
		props: {
			value: [String, Array],
			split: {
				type: String,
				default: ','
			}
		},
		
		computed: {
			tags() {
				return typeof this.value == 'object' ? this.value : this.value.split(this.split) || [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.u-tags {
		display: contents;

		.item {
			height: .36rem;
			padding: 0 .16rem;
			border-radius: .16rem;
			font-size: .24rem;
			line-height: .36rem;
			color: #333;
			background: #F5F5F5;
		}
	}
</style>
